var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "green-operation-documents" },
    [
      _vm.canManageDocuments
        ? [
            _c("div", { staticClass: "section-desc" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("tenancy.greenOperation.uploadHint")) +
                  "\n    "
              ),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.canManageDocuments ||
                _vm.canSendReminder ||
                _vm.fileList.length !== 0,
              expression:
                "canManageDocuments || (canSendReminder || fileList.length !== 0)",
            },
          ],
          staticClass: "green-operation-documents__upload-zone",
        },
        [
          _vm.canManageDocuments
            ? [
                _c(
                  "HKLDDropzone",
                  _vm._b(
                    { ref: "dropzoneRef" },
                    "HKLDDropzone",
                    _vm.dropzoneAttrs,
                    false
                  )
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("HKLLeftRight", {
            staticClass: "green-operation-documents__upload-actions",
            scopedSlots: _vm._u(
              [
                _vm.canEditFileList.length
                  ? {
                      key: "left",
                      fn: function () {
                        return [
                          _vm.isTenant
                            ? _c("DocumentsSubmitButtonNModal", {
                                ref: "submitModal",
                                attrs: { action: "submitForReview" },
                                on: {
                                  onOkClick: _vm.submitForReview,
                                  open: _vm.onOpenSubmitModal,
                                },
                              })
                            : _vm.canSubmit
                            ? _c("DocumentsSubmitButtonNModal", {
                                ref: "submitModal",
                                attrs: { action: "submitForReview" },
                                on: {
                                  onOkClick: _vm.submitForReview,
                                  open: _vm.onOpenSubmitModal,
                                },
                              })
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
                !_vm.isTenant && _vm.canSendReminder
                  ? {
                      key: "right",
                      fn: function () {
                        return [
                          _c("HKLButton", {
                            attrs: {
                              color: "darkblue",
                              action: "sendReminder",
                            },
                            on: {
                              click: function () {
                                return _vm.openSendReminderModal()
                              },
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          }),
          _vm._v(" "),
          _c(
            "HKLForm",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.fileList.length,
                  expression: "fileList.length",
                },
              ],
              ref: "formRef",
            },
            [
              _c(
                "HKLAttachment",
                _vm._b(
                  {
                    ref: "attachmentRef",
                    staticClass: "green-operation-documents__attachment-list",
                    class: _vm.attachmentClass,
                    attrs: { sourceId: _vm.greenOperation.id },
                    on: {
                      updateFiles: function (files) {
                        return (_vm.fileList = files)
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "file-after",
                        fn: function (ref) {
                          var metaData = ref.metaData
                          return [
                            _vm.hasSubmittedHistory(metaData)
                              ? _c(
                                  "HKLGrayHint",
                                  {
                                    staticClass:
                                      "green-operation-documents__submitted-hint",
                                    attrs: { fontSize: 11 },
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.$t("submittedByOn", [
                                            metaData.submittedHistories[0]
                                              .displayName,
                                            _vm.parseSubmitDate(
                                              metaData.submittedHistories[0]
                                                .createdAt
                                            ),
                                          ])
                                        ) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  },
                  "HKLAttachment",
                  _vm.attachmentAttrs,
                  false
                )
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c("GreenOperationReminderModal", { ref: "sendReminderModal" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }